export const ENDPOINTS = {
  CONTENT: {
    BASE: '/content',
    BANNER: '/content/upskill/banners',
    INFO_BANNER: 'content/upskill/infoBanners'
  },
};
